import { LoginResponse } from "app/api/busha/types";
import PinInput from "app/components/PinInput";
import useConfirmLogin from "../hooks/useConfirmLogin";
import React from "react";
import Text from "app/styles/Text";
import { useNavigate } from "react-router-dom";
import {
  AppStateActions,
  useAppDispatch,
} from "app/providers/AppStateProvider";
import { BUSHA_ROOT, BUSHA_TRANSFER_CONFIRM_PAGE } from "app/constants/routes";
import tw from "twin.macro";
import SubHeader from "app/styles/SubHeader";

export default function OtpForm({
  initializationData,
}: {
  initializationData: LoginResponse;
}) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { confirmLogin, error, isLoading } = useConfirmLogin();

  const onSubmit = (code: string) => {
    confirmLogin({ code, token: initializationData.confirmation_token! }, {
      onSuccess: (data) => {
        dispatch({
          type: AppStateActions.setBushaAuthToken,
          payload: data.data.access_token,
        });

        navigate(`${BUSHA_ROOT}/${BUSHA_TRANSFER_CONFIRM_PAGE}`, { replace: true });
      },
    });
  };

  return (
    <div tw="flex flex-col gap-[24px] justify-center pb-[24px]">
      <div tw="flex flex-col gap-[8px]">
        <SubHeader css={tw`headline-medium`}>Login to Busha account</SubHeader>

        <Text tw="body-large text-text-mid w-[430px] max-w-full">
          {initializationData?.message ??
            "Please check your authenticator app for your generated 6-digit code."}
        </Text>
      </div>

      <div tw="flex flex-col gap-[12px]">
        <PinInput
          onPinCompleted={onSubmit}
          error={!!error}
          errorMessage={error ?? ""}
          disabled={isLoading}
        />

        <Text css={tw`body-small`}>
          Having trouble?{" "}

          <button type="button" tw="text-action-constructive">
            Contact support
          </button>
        </Text>
      </div>
    </div>
  );
}
